import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";
import { initSentry } from "@/lib/sentry";
import { initAuthStorage, setupAuthPersistenceHooks, restoreSessionSync } from "@/lib/authStorage";

initSentry();
restoreSessionSync();
setupAuthPersistenceHooks();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

initAuthStorage().catch(() => {});

if ("serviceWorker" in navigator) {
  let swReloaded = false;

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (swReloaded) return;
    swReloaded = true;
    window.location.reload();
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { updateViaCache: "none" })
      .then((reg) => {
        reg.update();
        return navigator.serviceWorker.ready;
      })
      .then(() => initAuthStorage())
      .catch(() => {});
  });
}